import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchHobbyData } from "services/apis";


const initialState = {
  hobbyData: [], 
  status: "idle", 
  loading: false,
  error: null,
};


export const getHobbyData = createAsyncThunk(
  "hobbys/fetchhobbyData",
  async (_, { rejectWithValue }) => {
    try {
      const response = await fetchHobbyData(); 
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message || "Failed to fetch hobby data");
    }
  }
);


const hobbyDataSlice = createSlice({
  name: "hobbyData",
  initialState,
  reducers: {
    
  },
  extraReducers: (builder) => {
    builder
      .addCase(getHobbyData.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.status = "loading";
      })
      .addCase(getHobbyData.fulfilled, (state, action) => {
        state.loading = false;
        state.hobbyData = action.payload; 
        state.status = "succeeded";
      })
      .addCase(getHobbyData.rejected, (state, action) => {
        state.loading = false;
        state.status = "failed";
        state.error = action.payload; 
      });
  },
});

export default hobbyDataSlice.reducer;